<template>
  <div>
    <div id="wrapper" class="main">
      <header id="header" class="header" :class="gnbClass" @mouseleave="gnb_close">
        <div class="header-inner">
          <div class="head-title">
            <!-- 모바일 헤더 -->
            <h1 class="main-logo">
              <router-link to="/">
                <img src="@/assets/images/Golf/logo_golf_col_color.png" alt="" />
              </router-link>
            </h1>
          </div>
          <strong>
            <a href="#">
              <router-link to="/">
                <img :src="logoImage" class="logo" alt="" />
              </router-link>
            </a>
          </strong>
          <button type="button" class="btn-gnb-open" @click="mobileOpen">
            <span class="bar"></span>
            <span class="blind">메뉴열기</span>
          </button>
          <nav id="nav">
            <div class="nav-inner">
              <div class="util-menu">
                <div class="menu">
                  <div class="lang-list">
                    <div class="lang" @click="siteDropDownShow">
                      <span class="selected"> 사이트이동 </span>
                    </div>
                    <ul
                      class="select-lang"
                      v-show="isSiteDropDownShow"
                      style="width: 145%"
                      @mouseleave="siteDropDownHide"
                    >
                      <li>
                        <a href="#"><span>PODO HOTEL</span></a>
                      </li>
                      <li>
                        <a href="#"><span>THE ANNEX</span></a>
                      </li>
                      <li>
                        <a href="#"><span>BIOTOPIA</span></a>
                      </li>
                      <li>
                        <a href="#"><span>P-LEISURE</span></a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="welcome">
                  <p>
                    환영합니다. <br />
                    <a href="/main/ko/member/login" class="login">로그인 해주세요</a>
                  </p>
                </div>

                <div class="single-menu" v-show="isLogin">
                  <div class="single-menu">{{ userName }} 님 환영합니다.</div>
                  <div class="single-menu-seperate">|</div>
                  <div class="single-menu">
                    <router-link to="/p/MyPage"> 마이페이지</router-link>
                  </div>
                  <div class="single-menu-seperate">|</div>
                  <div class="single-menu" @click="logout">
                    <a href="#"><span>로그아웃</span></a>
                  </div>
                </div>

                <div class="single-menu" v-show="!isLogin">
                  <div class="single-menu">
                    <router-link to="/p/Login"> 로그인</router-link>
                  </div>
                </div>

                <div class="util-menu-group top">
                  <div class="mob-top-line">
                    <!--                    <a href="#" class="menu sky"><span></span></a>-->
                    <a href="#" class="menu mob-view2"><span>멤버십</span></a>
                  </div>
                </div>

                <div class="util-menu-group bottom">
                  <!--                  <a href="#" class="menu web-view2"><span>멤버십 사이트</span></a>-->
                </div>
                <div class="menu">
                  <div class="lang-list">
                    <div class="lang" @click="langDropDownShow">
                      <span class="selected">{{ selectedLanguage }}</span>
                    </div>
                    <ul
                      class="select-lang"
                      v-show="isLangDropDownShow"
                      @click="langDropDownShow"
                      @mouseleave="langDropDownHide"
                    >
                      <li @click="langSelected('한국어')">
                        <a href="#"><span>한국어</span></a>
                      </li>
                      <li @click="langSelected('English')">
                        <a href="#"><span>English</span></a>
                      </li>
                      <li @click="langSelected('日本語')">
                        <a href="#"><span>日本語</span></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="gnb-area">
                <router-link to="/">
                  <img :src="logoImage" class="logo" alt="" />
                </router-link>
                <ul class="gnb-menu">
                  <li v-for="(header, index) in headers" :key="index" @mouseover="gnb_open">
                    <a href="#" target="_self">
                      <span @click="topmenuClick(index)">{{ header.topMenu }}</span>
                    </a>
                    <ul class="depth2" :style="subUlClass(index)">
                      <li v-for="(sub, index2) in header.subMenu" :key="index2">
                        <router-link :to="sub.link">
                          <span>{{ sub.text }}</span>
                        </router-link>
                        <!--                        <a href="#" target="_self">-->
                        <!--                          <span>{{ sub.text }}</span>-->
                        <!--                        </a>-->
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <button type="button" class="btn-gnb-close ico-close"><span class="blind">메뉴닫기</span></button>
            </div>
          </nav>
        </div>
      </header>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GnbDownMenu',
  props: {
    headers: Array,
  },
  mounted() {
    if (this.$router.currentRoute.path === '/') {
      //ASDF
      this.gnbClass = {
        'with-line': false,
        'color-bright': true,
        'gnb-open': false,
        scroll: false,
      };
    } else {
      this.gnbClass = {
        'with-line': true,
        'color-bright': false,
        'gnb-open': false,
        scroll: false,
      };
    }

    if (this.$router.currentRoute.path === '/') {
      this.logoImage = require('@/assets/images/Golf/logo_golf_col_white.png');
    } else {
      this.logoImage = require('@/assets/images/Golf/logo_golf_col_color.png');
    }
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  data() {
    return {
      logoImage: null,
      gnbClass: {
        'with-line': false,
        'color-bright': true,
        'gnb-open': false,
        scroll: false,
      },
      selectedSubmenuIndex: -1,
      isLangDropDownShow: false,
      selectedLanguage: '한국어',
      isSiteDropDownShow: false,
    };
  },
  computed: {
    isLogin() {
      return this.$store.getters['Auth/isLoggedIn'];
    },
    loginUser() {
      return this.$store.getters['Auth/loginUser'];
    },
    userName() {
      if (this.loginUser) {
        return this.loginUser.guestName;
      } else {
        return '';
      }
    },
  },
  watch: {
    $route(to, from) {
      if (to.path === '/') {
        this.logoImage = require('@/assets/images/Golf/logo_golf_col_white.png');
        this.gnbClass = {
          'with-line': false,
          'color-bright': true,
          'gnb-open': false,
          scroll: false,
        };
        this.gnbClass['with-line'] = false;
      } else {
        this.logoImage = require('@/assets/images/Golf/logo_golf_col_color.png');
        this.gnbClass = {
          'with-line': true,
          'color-bright': false,
          'gnb-open': false,
          scroll: false,
        };
        // this.gnbClass['with-line'] = true;
        console.log('NOT-HOME', this.gnbClass);
      }
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('Auth/signOut', '');

      if (this.$router.currentRoute.path !== '/') {
        this.$router.replace('/');
      }
    },
    siteDropDownShow() {
      this.isSiteDropDownShow = !this.isSiteDropDownShow;
    },

    siteDropDownHide() {
      this.isSiteDropDownShow = false;
    },
    langDropDownShow() {
      this.isLangDropDownShow = !this.isLangDropDownShow;
    },
    langDropDownHide() {
      this.isLangDropDownShow = false;
    },
    langSelected(lang) {
      this.selectedLanguage = lang;
    },

    subUlClass(idx) {
      if (this.selectedSubmenuIndex == idx) {
        return {
          display: 'block',
        };
      } else {
        return {
          display: 'none',
        };
      }
    },
    topmenuClick(idx) {
      console.log('???');
      this.selectedSubmenuIndex = idx;
    },
    submenuClick() {
      // console.log('submenuClicked');
      // window.scrollTo(0, 0);
      // this.gnbClass = {
      //   'with-line': this.gnbClass['with-line'],
      //   'color-bright': this.gnbClass['color-bright'],
      //   'gnb-open': false,
      //   scroll: false,
      // };
    },
    mobileOpen() {
      this.gnbClass = {
        'm-gnb-open': true,
      };
    },

    gnb_open() {
      if (this.gnbClass['m-gnb-open']) return;

      this.logoImage = require('@/assets/images/Golf/logo_golf_col_color.png');
      this.gnbClass = {
        'with-line': false,
        'color-bright': this.$router.currentRoute.path === '/',
        'gnb-open': true,
        'm-gnb-open': false,
        scroll: this.gnbClass.scroll,
      };

      this.selectedSubmenuIndex = -1;
    },

    gnb_close() {
      if (window.scrollY > 0) {
        this.logoImage = require('@/assets/images/Golf/logo_golf_col_color.png');
      } else {
        if (this.$router.currentRoute.path === '/') {
          this.logoImage = require('@/assets/images/Golf/logo_golf_col_white.png');
        } else {
          this.logoImage = require('@/assets/images/Golf/logo_golf_col_color.png');
        }
      }
      this.gnbClass = {
        'with-line': this.$router.currentRoute.path !== '/',
        'color-bright': this.$router.currentRoute.path === '/',
        'gnb-open': false,
        'm-gnb-open': false,
        scroll: this.gnbClass.scroll,
      };

      this.selectedSubmenuIndex = -1;

      console.log('gnb-close', this.gnbClass);
    },

    handleScroll() {
      if (window.scrollY > 0) {
        this.logoImage = require('@/assets/images/Golf/logo_golf_col_color.png');

        this.gnbClass = {
          'with-line': false,
          'color-bright': this.$router.currentRoute.path === '/',
          'gnb-open': this.gnbClass['gnb-open'],
          'm-gnb-open': false,
          scroll: window.scrollY > 0,
        };
      } else {
        if (this.$router.currentRoute.path === '/') {
          this.gnbClass = {
            'with-line': false,
            'color-bright': this.$router.currentRoute.path === '/',
            'gnb-open': this.gnbClass['gnb-open'],
            'm-gnb-open': false,
            scroll: window.scrollY > 0,
          };
          this.logoImage = require('@/assets/images/Golf/logo_golf_col_white.png');
        } else {
          this.gnbClass = {
            'with-line': true,
            'color-bright': this.$router.currentRoute.path === '/',
            'gnb-open': this.gnbClass['gnb-open'],
            'm-gnb-open': false,
            scroll: window.scrollY > 0,
          };
          this.logoImage = require('@/assets/images/Golf/logo_golf_col_color.png');
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
//@import './css/common.css';
//@import './css/gnb.css';

.logo {
  margin-left: 30px;
  width: 195px;
  height: 36px;
  vertical-align: baseline;
}
</style>
